import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";

const labels: { [index: string]: string } = {
  0.5: "10%",
  1: "20%",
  1.5: "30%",
  2: "40%",
  2.5: "50%",
  3: "60%",
  3.5: "70%",
  4: "80%",
  4.5: "90%",
  5: "100%",
};

export default function HoverRating({
  value,
  setValue,
  readOnly,
}: {
  value: number | null;
  setValue: (v: number | null) => void;
  readOnly: boolean;
}) {
  const [hover, setHover] = useState(-1);

  return (
    <Box
      sx={{
        width: 200,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Rating
        name="hover-feedback"
        value={value}
        precision={0.5}
        readOnly={readOnly}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
      />
      {value !== null && (
        <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : value]}</Box>
      )}
    </Box>
  );
}
